import { Col, Form, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { LeftOutlined } from '@ant-design/icons';
import Typography from '../components/Typography';
import { COLORS } from '../constants/Colors';
import SearchCard from '../components/SearchCard';
import CustomerList from '../components/CustomerList';
import CustomerModal from '../components/CustomerModal';
import CustomerProfileCard from '../components/CustomerProfileCard';
import CustomerAddressList from '../components/CustomerAddressList';
import CustomerAddressModal from '../components/CustomerAddressModal';
import { instance } from '../components/AxiosClient';
import GetProfile from '../components/VariableStore';
import _ from 'lodash';
import {
  errorNotification,
  successNotification,
} from '../components/Notification';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDebounce } from '../utils/hooks/useDebounce';
import '../components/style/customer.css'

const Customer = () => {
  const intl = useIntl()
  const isDesktop = useIsDesktop();
  const [isOpenCustomerModal, setIsOpenCustomerModal] = useState(false);
  const [isOpenCustomerAddressModal, setIsOpenCustomerAddressModal] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [visiblePopContact, setVisiblePopContact] = useState(false);

  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [event, setEvent] = useState(false);
  const [eventAddress, setEventAddress] = useState(false);

  const [contactData, setContactData] = useState([]);
  const [customerData, setCustomerData] = useState();

  const [addressData, setAddressData] = useState([]);
  const [addressEditData, setAddressEditData] = useState([]);
  const [contactSearch, setContactSearch] = useState('');
  const [createSearch, setCreateSearch] = useState('');
  const [form] = Form.useForm();
  const [formAddress] = Form.useForm();

  const [selectArea, setSelectArea] = useState(false);
  const [spinning, setSpinning] = useState(false)
  const [isSelect, setIsSelect] = useState(false);
  const [addressArea, setAddressArea] = useState();


  const parsLocal = JSON.parse(localStorage.getItem('persist:loop_store'))
  const customerDataLocal = JSON.parse(parsLocal.customerProfileReducer)

  const comCode = GetProfile('customerCode') || _.get(customerDataLocal, 'comCode');
  const customerId = GetProfile('customerId') || _.get(customerDataLocal, 'customerId');

  useEffect(() => {
    getData();
  }, [event]);

  useEffect(() => {
    if (customerData) {
      getDataAddress(customerData);
    }
  }, [eventAddress]);

  const getData = async () => {
    setSpinning(true)
    try {
      const response = await instance.get(
        `/v3/business-partner/manager/company/${comCode}/customer-informations/${customerId}`
      );
      setContactData(response.data.data.contacts);
      if (_.size(customerData) > 0) {
        handleClickCustomer(
          _.get(
            _.filter(response.data.data.contacts, (e) => {
              return (
                e.customerContactId === _.get(customerData, 'customerContactId')
              );
            }),
            '[0]'
          )
        );
      }

    } catch (error) { }
    setSpinning(false)
  };

  const getDataAddress = async (contactId) => {
    try {
      const response = await instance.get(
        `/v3/business-partner/manager/company/${comCode}/customer-address-books?customerId=${customerId}&contactId=${contactId.customerContactId}`
      );
      setAddressData(response.data.data);
    } catch (error) { }
  };

  const handleCancelCustomerForm = () => {
    form.resetFields();
    setisEdit(false);
    setIsOpenCustomerModal(false);
  };

  const handleCancelCustomerAddressForm = () => {
    setIsOpenCustomerAddressModal(false);
    formAddress.resetFields();
  };

  const handleOpenCustomerForm = (type) => {
    const isEditType = type === 'edit';
    if (isEditType) {
      setisEdit(true);
    } else {
      setCustomerData();
      setisEdit(false);
    }

    if (type === contactSearch && _.size(contactData) === 0) {
      setCreateSearch(contactSearch);
    } else {
      setCreateSearch('');
    }

    if (isEditType === true) {
      form.setFieldsValue({
        name: _.get(customerData, 'customerContactName'),
        phone: _.get(customerData, 'customerContactPhone'),
        email: _.get(customerData, 'customerContactEmail'),
        remark: _.get(customerData, 'remark'),
      });
    } else {
      form.setFieldsValue({
        name: createSearch ? createSearch : '',
      });
    }
    setIsOpenCustomerModal(true);
  };

  const handleSplitText = (value) => {
    const text = _.split(value, "·")
    const filterName = text.slice(1).join(" ");
    return filterName ? filterName : value
  }


  const handleOpenCustomerAddressForm = (type, id) => {
    const isEditType = type === 'edit';
    if (isEditType) {
      setSelectArea(true);
      setAddressEditData(id);
      setisEdit(true);
      setIsSelect(true)
      formAddress.setFieldsValue({
        addressname: handleSplitText(_.get(id, 'addressName')),
        address: _.get(id, 'address2'),
        fulladdress: _.get(id, 'subDistrict') + ", " + _.get(id, 'district') + ", " + _.get(id, 'province') + ", " + _.get(id, 'postCode'),
      });
      setAddressArea({
        addressName: _.get(id, 'subDistrict') + ", " + _.get(id, 'district') + ", " + _.get(id, 'province') + ", " + _.get(id, 'postCode'),
        subDistrictName: _.get(id, 'subDistrict'),
        districtName: _.get(id, 'district'),
        provinceName: _.get(id, 'province'),
        zipCode: _.get(id, 'postCode'),
      });
    } else {
      formAddress.resetFields();
      setAddressEditData([]);
      setisEdit(false);
    }

    setIsOpenCustomerAddressModal(true);
  };

  const handleClickCustomer = (focusCustomer) => {
    setCustomerData(focusCustomer);
    getDataAddress(focusCustomer);
    setIsOpenInfo(true);
  };

  const handleSerchCustomer = (values) => {
    if (values === '') {
      getData();
    } else {
      setContactSearch(values);
      const Search = _.filter(contactData, (item) => {
        return item.customerContactName.indexOf(values) > -1;
      });
      setContactData(Search);
    }
  };

  const onClickDelete = async (id) => {
    const comCode = GetProfile('customerCode');
    const contactId = _.get(id, 'customerContactId');
    try {
      const response = await instance.delete(
        `/v3/business-partner/manager/company/${comCode}/customer-contacts/${contactId}`
      );
      setIsOpenDelete(false);
      setEvent((current) => !current);
      setIsOpenInfo(false);
      setCustomerData([]);
      successNotification(intl.formatMessage({ id: 'deleteSuccessNotification', defaultMessage: 'Success' }));
      // successNotification(_.get(response, 'Delete Success'));
    } catch (error) {
      errorNotification(intl.formatMessage({ id: 'deleteErrorNotification', defaultMessage: 'Failed' }));
    }
  };

  const onClickDeleteAddress = async (id) => {
    const customerAddressBookId = _.get(id, 'customerAddressBookId');
    try {
      const response = await instance.delete(
        `/v3/business-partner/manager/company/${comCode}/customer-address-books/${customerAddressBookId}`
      );
      setIsOpenDelete(false);
      setEventAddress((current) => !current);
      successNotification(intl.formatMessage({ id: 'deleteSuccessNotification', defaultMessage: 'Success' }));
    } catch (error) {
      errorNotification(intl.formatMessage({ id: 'deleteErrorNotification', defaultMessage: 'Failed' }));
    }
  };

  const handleChangeSearch = (value) => {
    if (value) {
      const includeValue = _.filter(addressData, (item) => {
        return item.addressName.includes(value) || item.address.includes(value)
      })
      setAddressData(includeValue)
    } else {
      getDataAddress(customerData);
    }

  }

  //console.log("addressData", addressData)

  return (
    // <MainLayout isMainPage>
    <div className='d-flex flex-column w-100 h-100 p-3 justify-content-between'>
      <Spin spinning={spinning}>
        <div style={{ marginBottom: "10px" }}>
          {isOpenInfo ? (
            <div>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setIsOpenInfo(false);
                      setCustomerData();
                    }}
                  >
                    <Typography color={COLORS.Gray} className='text-left'>
                      <LeftOutlined className='px-3' />
                      <FormattedMessage id="btnBack" defaultMessage="Back" />
                    </Typography>
                  </div>
                </Col>
                <Col span={24}>
                  <CustomerProfileCard onClickEdit={handleOpenCustomerForm} customerData={customerData} onClickDelete={onClickDelete} />
                </Col>
                <Col span={24}>
                  <CustomerAddressList
                    onCreateAddress={handleOpenCustomerAddressForm}
                    onClickEditAddress={handleOpenCustomerAddressForm}
                    addressData={addressData}
                    setEventAddress={setEventAddress}
                    onClickDeleteAddress={onClickDeleteAddress}
                    customerData={customerData}
                    handleChangeSearch={handleChangeSearch}
                  />
                </Col>
              </Row>
            </div>
          ) : (
            <div>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <SearchCard handleSerchCustomer={handleSerchCustomer} />
                </Col>
                <Col span={24}>
                  <CustomerList
                    onClickCustomer={handleClickCustomer}
                    onCreateCustomer={handleOpenCustomerForm}
                    onClickEditCustomer={() => handleOpenCustomerForm('edit')}
                    contactData={contactData}
                    contactSearch={contactSearch}
                    onClickDelete={onClickDelete}
                    isOpen={isOpenDelete}
                    setIsOpen={setIsOpenDelete}
                    visible={visiblePopContact}
                    setVisible={setVisiblePopContact}
                  />
                </Col>
              </Row>
            </div>
          )}
        </div>
        {/* <Typography isBold className={`text-center w-100 ${isDesktop ? 'pb-3' : 'pb-1'} pt-1`} size={isDesktop ? '18px' : '14px'} color={COLORS.Gray}>
        <FormattedMessage id="textCustomerService" defaultMessage="Customer Service : 02-111-0099" />
        </Typography> */}
        {!isDesktop && (
          <div
            className={`d-flex align-items-center ${isDesktop ? 'justify-content-start' : 'justify-content-center'} px-4`}
            style={{
              height: 46,
              backgroundColor: COLORS.Primary,
              padding: '24px',
              width: '100vw',
              marginLeft: '-16px',
              // marginTop: "16px",
              marginBottom: '-16px',
            }}
          >
            <Typography size='12.5px' color={COLORS.White}>
              Powered by © RAPIDTECH Co., Ltd. (V 1.0)
            </Typography>
          </div>
        )}
      </Spin>
      <CustomerModal
        isOpen={isOpenCustomerModal}
        onCancle={handleCancelCustomerForm}
        isEdit={isEdit}
        createSearch={createSearch}
        customerData={customerData}
        form={form}
        setEvent={setEvent}
      />
      <CustomerAddressModal
        isOpen={isOpenCustomerAddressModal}
        setIsOpenAddrModal={setIsOpenCustomerAddressModal}
        onCancle={handleCancelCustomerAddressForm}
        isEdit={isEdit}
        customerData={customerData}
        form={formAddress}
        addressEditData={addressEditData}
        selectArea={selectArea}
        setSelectArea={setSelectArea}
        setEventAddress={setEventAddress}
        setIsSelect={setIsSelect}
        isSelect={isSelect}
        setAddressArea={setAddressArea}
        addressArea={addressArea}
      />
    </div>
    // </MainLayout >
  );
};

export default Customer;
